










































































































import Vue from 'vue';
import Component from 'vue-class-component';
import FormNavigationButtons from '../common/FormNavigationButtons.vue';
import { Watch, Prop } from 'vue-property-decorator';
import * as rules from '@/modules/shared/shared/domain/rules';
import { user } from '@/modules/shared/shared/store/namespaces';
import { AssistanceTypingsInterface } from '@/components/tickets/tickets-form/interfaces/assistance.typings.interface';
import PhoneField from '@/modules/shared/shared/components/PhoneField.vue';
@Component({
    components: {
        PhoneField,
        FormNavigationButtons,
    },
})
export default class StepGeneralInformation extends Vue {
    @Prop({ required: true })
    formValues!: {
        typings: {
            subCategories: AssistanceTypingsInterface[];
        };
    };

    isFormValid: boolean = true;
    modalCheck: boolean = true;
    $refs!: {
        form: any;
    };
    rules: any = rules;
    generalInformation: {
        contactId: number;
        firstName: string;
        lastName: string;
        idNumber: string;
        telephoneNumber: string;
        subCategory: AssistanceTypingsInterface | null;
        subject: AssistanceTypingsInterface | null;
        description: string;
    } = {
        contactId: 0,
        firstName: '',
        lastName: '',
        idNumber: '',
        telephoneNumber: '',
        description: '',
        subject: null,
        subCategory: null,
    };

    @Watch('generalInformation.subject')
    generalInformationSubject(value: any, oldValue: any) {
        this.$emit('getRequirementTypingSelected', value);
    }

    sendData() {
        return { generalInformation: this.generalInformation };
    }
    validateStep() {
        if (this.$refs.form.validate()) {
            this.$emit('nextStep');
        }
    }

    previousStep() {
        this.$emit('previousStep');
    }

    get items() {
        if (this.generalInformation.subCategory) {
            return this.generalInformation.subCategory.subjects;
        }
        return [];
    }

    mounted() {
        this.generalInformation.contactId = this.contact.id;
        this.generalInformation.firstName = this.contact.name;
        this.generalInformation.lastName = this.contact.lastName;
        this.generalInformation.idNumber = this.contact.ci;
        this.generalInformation.telephoneNumber = this.contact.phone;
    }

    @user.State('contact') contact;
}
